import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ModalComponent } from '../../../../core/config/core.modal-helpers';
import { BoardRest } from '../board.rest';

@Component({
    selector: 'board-delete-modal',
    template: `<div class="modal-content">
    <div class="modal-header">
        <button type="button" class="close" (click)="close.emit()" data-dismiss="modal"
            aria-hidden="true">&times;</button>
        <h3 class="modal-title"><span translate>Delete Planning Board</span></h3>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-xs-12">
                <p><span translate>Are you sure you want to delete</span>&nbsp;<strong>{{board.boardName}}</strong>?</p>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="btn-toolbar">
            <div class="btn-group pull-right">
                <button (click)="close.emit(false)" data-dismiss="modal"
                    class="btn btn-default" style="margin-right:10px;"
                    title="Close, cancel changes">
                    <span translate>Cancel</span>
            </button>
                <button (click)="deleteBoard()" class="btn btn-danger" title="Delete Board">
                    <i class="glyphicon glyphicon-check"></i>
                    <span translate>Delete</span>
                </button>
            </div>
        </div>
    </div>
</div>`
})
export class BoardDeleteModalComponent extends ModalComponent {

    @Input() project: any = null;
    @Input() board: any = null;

    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

    isLoading = false;

    constructor(
        private boardRest: BoardRest,
    ) { super(); }

    deleteBoard() {
        return this.boardRest.deleteBoard(this.board.id)
            .then((response) => {
                this.close.emit(true);
            })
            .catch((response) => {
                console.log(response);
            });
    };
}